// extracted by mini-css-extract-plugin
export default {"DivBackgroundWrapper":"_SharedStyles_DivBackgroundWrapper__fiWcf","DivBackgroundWrapperDark":"_SharedStyles_DivBackgroundWrapperDark__6M5rP"};